import { render, staticRenderFns } from "./OfficialPost.vue?vue&type=template&id=5f4912a0&scoped=true"
import script from "./OfficialPost.vue?vue&type=script&lang=js"
export * from "./OfficialPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4912a0",
  null
  
)

export default component.exports